import { sdk } from 'src/utilities/sdk';
import { CorpUIResponse, ICorpResponse } from 'src/types/Corp';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export const getCorporateDetailsEndpoint = (corpId: string): string =>
  `/corps/${corpId}`;

export async function getCorporateDetails(
  corpId: string
): Promise<CorpUIResponse> {
  const corpData: ICorpResponse = await sdk.http.get(
    getCorporateDetailsEndpoint(corpId)
  );
  return camelizeResponseData(corpData);
}
